export const YES_NO_OPTIONS = [
  { label: "Tout", value: "" },
  { label: "Oui", value: "OUI" },
  { label: "Non", value: "NON" },
];

export const AUTH_TOKEN_NAME = "TIABISESSIONID";
export const AUTH_JSESSION_NAME = "JSESSIONID";
